// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/SubaccountsInvoices_CancelarInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /subaccounts/invoices/cancelar/{id}
 * id is a URL path parameter. `justificativa` is optional in the envelope —
 * Chile posts an empty body ({}); InvoiceService::cancelar() enforces the
 * 15-255 char requirement itself, conditionally, only when the franchise's
 * provider is 'focus_nfe'.
 */
import { registerContract } from './validate'

export interface SubaccountsInvoices_CancelarInput {
justificativa?: string
}

registerContract('SubaccountsInvoices_CancelarInput', {
  justificativa: { type: 'string',  required: false },
})
